import { useState, useCallback } from 'react';

export const useNotification = () => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, type = 'info', duration = 3000) => {
    setNotification({ message, type, duration });
  }, []);

  const hideNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return {
    notification,
    showNotification,
    hideNotification,
    showSuccess: useCallback((message, duration) => showNotification(message, 'success', duration), [showNotification]),
    showError: useCallback((message, duration) => showNotification(message, 'error', duration), [showNotification]),
    showWarning: useCallback((message, duration) => showNotification(message, 'warning', duration), [showNotification]),
    showInfo: useCallback((message, duration) => showNotification(message, 'info', duration), [showNotification]),
  };
};
